import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1976d2", // Blue color for primary actions
        },
        secondary: {
            main: "#ff4081", // Pink color for secondary actions
        },
        background: {
            default: "var(--oc-page-bg, #FAF9F6)",
        },
    },
    typography: {
        fontFamily: "'Montserrat', 'Arial', sans-serif",
        h1: {
            fontFamily: "'Dala Floda', serif",
            fontSize: "2.5rem",
            fontWeight: 500,
        },
        h2: {
            fontFamily: "'Dala Floda', serif",
            fontSize: "2rem",
            fontWeight: 500,
        },
        body1: {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "1rem",
            fontWeight: 400,
            color: "var(--oc-text, #1a1a1a)",
        },
        body2: {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "0.875rem",
            fontWeight: 400,
            color: "var(--oc-text-muted, #666666)",
        }
    },
    components: {
        MuiSelect: {
            styleOverrides: {
                root: {
                    "&:before": {
                        borderBottom: "1px solid #999 !important", // Default underline color
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: "2px solid #7C624B !important", // Hover color
                    },
                    "&:after": {
                        borderBottom: "2px solid #7C624B !important", // Focus color
                    },
                    "&.Mui-disabled:before": {
                        borderBottom: "1px solid #ccc !important", // Disabled state
                    },

                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        backgroundColor: "rgba(200, 200, 200, 0.3) !important",
                    },
                    "&.Mui-selected:hover": {
                        backgroundColor: "rgba(180, 180, 180, 0.4) !important",
                    },
                },
            },
        },
    },
});

export default theme;
